import { X } from '@phosphor-icons/react';

import styles from './styles.module.scss';

/**
 * Sheet shell shared by the date / time / place / verify steps — bottom sheet
 * on mobile, centred card on desktop. Same look as common/chat/BirthDateModal.
 */
const Sheet = ({ title, onClose, closeLabel, children }) => (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label={title}>
        <div className={styles.card}>
            <div className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                <button type="button" className={styles.close} onClick={onClose} aria-label={closeLabel}>
                    <X size={24} color="#ffffff" />
                </button>
            </div>
            {children}
        </div>
    </div>
);

export default Sheet;
